<script setup>
import {onMounted, defineEmits, ref, defineProps, defineExpose} from 'vue'

// Props & emits
let emit = defineEmits(['file-updated', 'delete-file', 'changed'])

const props = defineProps({
  activeRequestFields: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const defaultFormData = {
  geo: '',
  email: '',
  legal_company_name: '',
  offer_url: '',
  address: '',
  preland_url: '',
  city: '',
  zip: '',
  auth_url: '',
  comment: '',
}
let formData = ref(cloneSafe(defaultFormData))

// Methods
onMounted(() => {
  init()
})

const init = () => {
  if (props.activeRequestFields) {
    formData.value = Object.assign(formData.value, props.activeRequestFields)
  }
}

const resetForm = () => {
  formData.value = cloneSafe(defaultFormData)
}

const onChange = () => {
  emit('changed', {fields: formData.value})
}

defineExpose({resetForm})
</script>

<template>
  <div class="form-group">
    <label for="snapchat-gambling-wl-email">Target GEO *</label>
    <div class="input-group">
      <input
        v-model="formData.geo"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-geo"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-email">Client Email *</label>
    <div class="input-group">
      <input
        v-model="formData.email"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-email"
        type="email"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-legal_company_name">Company Name *</label>
    <div class="input-group">
      <input
        v-model="formData.legal_company_name"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-legal_company_name"
        :disabled="disabled"
        required
      />
    </div>
  </div>

  <div class="form-group">
    <label for="snapchat-gambling-wl-offer_url">Offer URL *</label>
    <div class="input-group">
      <input
        v-model="formData.offer_url"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-offer_url"
        type="url"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-preland_url">Preland (If There is One)</label>
    <div class="input-group">
      <input
        v-model="formData.preland_url"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-preland_url"
        :disabled="disabled"
        type="url"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-address">Address (Street, House Number) *</label>
    <div class="input-group">
      <input
        v-model="formData.address"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-address"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-city">City *</label>
    <div class="input-group">
      <input
        v-model="formData.city"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-city"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-zip">Zip Code *</label>
    <div class="input-group">
      <input
        v-model="formData.zip"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-zip"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-country">Country (Principal Place of Business or Headquarters) *</label>
    <div class="input-group">
      <input
        v-model="formData.country"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-country"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-auth_url">URL to Authorization (or to a Google File With a Documents) *</label>
    <div class="input-group">
      <input
        v-model="formData.auth_url"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-auth_url"
        :disabled="disabled"
        type="url"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="snapchat-gambling-wl-comment">Any Comments That You Would Like to Add</label>
    <div class="input-group">
      <textarea
        v-model="formData.comment"
        @change="onChange"
        class="form-control"
        id="snapchat-gambling-wl-comment"
        :disabled="disabled"
        rows="3"
      />
    </div>
  </div>
</template>
